
export const CourseworkLocalStorageKeys = {
    AMI_COURSEWORK_USER_EMAIL_KEY:"ami-coursework-user-email",
    AMI_COURSEWORK_USER_ID_KEY:"ami-coursework-user-id",
    AMI_COURSEWORK_CODE_KEY:"ami-coursework-code",
};


export const removeCourseworkSession = () => {
    localStorage.removeItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_CODE_KEY);
    localStorage.removeItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_USER_ID_KEY);
    localStorage.removeItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_USER_EMAIL_KEY);
}









